// converts time from "09:00:00" to "09:00"
export const shortenTimeString = (time: string): string => {
  if (!time) return time
  const parts = time.split(':')
  if (parts.length === 3) return `${parts[0]}:${parts[1]}`
  return time
}
